import React from 'react'
import { MotivazioniNazioniNode, PaginaNode } from '@gql/graphql'
import { ContattaciForm, ListingHead, Page } from 'components/organisms'
import styles from './ContattaciTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  mainContent?: any
  motivazioniNazioni: MotivazioniNazioniNode
}

const ContattaciTemplate = (props: Props) => {
  const { pagina = undefined, mainContent = undefined, motivazioniNazioni = undefined } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main className={styles.layout}>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <ContattaciForm motivazioniNazioni={motivazioniNazioni} />
          <PlaceholderReact
            contentTypeId={pagina.model}
            objectId={pagina.pk}
            pkey={'main'}
            serverSideContent={mainContent}
          />
        </div>
      </main>
    </Page>
  )
}

export default ContattaciTemplate
